import { useEffect, useRef } from 'react';
import { useBrand } from '../../context/BrandContext';

// Runs onChange when the user switches brand (not on first render), so a
// report can drop selections that only exist in the previous brand's
// catalog, e.g. a provider name or a unique_game_id. Returns activeBrand
// for use as a data-fetch effect dependency.
export default function useBrandChange(onChange) {
  const { activeBrand } = useBrand();
  const previous = useRef(activeBrand);
  const callback = useRef(onChange);
  callback.current = onChange;

  useEffect(() => {
    if (previous.current === activeBrand) return;
    previous.current = activeBrand;
    callback.current();
  }, [activeBrand]);

  return activeBrand;
}
